exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Popup {\r\n\tposition: absolute;\r\n\tz-index: 99;\r\n\tvisibility: hidden;\r\n\ttransition: all .2s;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n}\r\n\r\n.Popup.Shown {\r\n\topacity: 1;\r\n\tvisibility: visible;\r\n}\r\n\r\n.Popup.Overlay {\r\n\tposition: fixed;\r\n\ttop: 0px;\r\n\tbottom: 0px;\r\n\tleft: 0px;\r\n\tright: 0px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Popup/Popup.css
// module id = 699
// module chunks = 0